import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// @ts-ignore medianIndex exist in d3-array@3.2.0, but @types/d3-array Expired.
import { maxIndex, minIndex, medianIndex } from 'd3-array';
import { createGroups } from './utils/order';
import { columnOf } from './utils/helper';
import { lttb } from './utils/lttb';
function normalizeSample(strategy) {
  if (typeof strategy === 'function') return strategy;
  if (strategy === 'lttb') return lttb;
  var strategies = {
    first: function first(f) {
      return [f[0]];
    },
    last: function last(f) {
      return [f[f.length - 1]];
    },
    min: function min(f, X, Y) {
      return [f[minIndex(f, function (i) {
        return Y[i];
      })]];
    },
    max: function max(f, X, Y) {
      return [f[maxIndex(f, function (i) {
        return Y[i];
      })]];
    },
    median: function median(f, X, Y) {
      return [f[medianIndex(f, function (i) {
        return Y[i];
      })]];
    }
  };
  var sampleFunction = strategies[strategy] || strategies.median;
  return function (I, X, Y, thresholds) {
    // Sepreate group to frames, then sample each frame.
    // Keep more data as possible.
    var frameSize = Math.max(1, Math.floor(I.length / thresholds));
    var frames = getFrames(I, frameSize);
    return frames.flatMap(function (frame) {
      return sampleFunction(frame, X, Y);
    });
  };
}
/**
 * Split the array into frame with each frameSize.
 */
function getFrames(I, frameSize) {
  var size = I.length;
  var frames = [];
  var i = 0;
  while (i < size) {
    frames.push(I.slice(i, i += frameSize));
  }
  return frames;
}
/**
 * The sample transform groups marks with specified groupBy fields, and
 * sample data for each group when data.length >= threshold(default = 2000).
 */
export var Sample = function Sample() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$strategy = options.strategy,
    strategy = _options$strategy === void 0 ? 'median' : _options$strategy,
    _options$thresholds = options.thresholds,
    thresholds = _options$thresholds === void 0 ? 2000 : _options$thresholds,
    _options$groupBy = options.groupBy,
    groupBy = _options$groupBy === void 0 ? ['series', 'color'] : _options$groupBy;
  var sampleFunction = normalizeSample(strategy);
  return function (I, mark) {
    var encode = mark.encode;
    var groups = createGroups(groupBy, I, mark);
    var _columnOf = columnOf(encode, 'x'),
      _columnOf2 = _slicedToArray(_columnOf, 1),
      X = _columnOf2[0];
    var _columnOf3 = columnOf(encode, 'y'),
      _columnOf4 = _slicedToArray(_columnOf3, 1),
      Y = _columnOf4[0];
    return [groups.flatMap(function (g) {
      return sampleFunction(g, X, Y, thresholds);
    }), mark];
  };
};
Sample.props = {};